import BackendSettings from '../modules/siteSettings/components/backendSettings/components'
import BankSettings from '../modules/siteSettings/components/bankSettings/components'
import ContactSetting from '../modules/siteSettings/components/contactSettings/ContactSetting'
import KeySettings from '../modules/siteSettings/components/keySetting/components'
import ModuleManager from '../modules/siteSettings/components/moduleManager/components/ModuleManager'
import Settings from '../modules/siteSettings/components/settings/components'
import SmtpSettings from '../modules/siteSettings/components/smtpSetting/components'
import Branches from '../modules/userMgmt/components/branch/components'
import ReportMenuComponent from '../modules/reportMenu/components'
import Departments from '../modules/userMgmt/components/departments/components'
import RoleManagementIndex from '../modules/userMgmt/components/roles/components/RoleMgmt'
import UserRoleManagementIndex from '../modules/userMgmt/components/userRoles/UserRole'
import UserManagementIndex from '../modules/userMgmt/components/users/components/users'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'

import {RouteComponentProps} from 'react-router-dom'
import ContentManager from 'src/app/modules/cms/components/content/components/index'
import MenuManager from '../modules/cms/components/menu/components'

import Banner from '../modules/cms/components/banner/components'

import RoadBlockPopup from '../modules/cms/components/roadblockPopup/components'
import TextPopup from '../modules/cms/components/textPopup/components'

import FaqCategory from '../modules/cms/components/faqCategory/components'
import FaqManager from '../modules/cms/components/faqManager/components'

import EmailTemplate from '../modules/cms/components/emailTemplate/components'
import FormDownloadComponent from '../modules/formsAndDownload/components/formsDownload/component'

import HomepageSetting from '../modules/siteSettings/components/homepageSettings/components'

import {lazy} from 'react'

import ProductSchema from '../modules/onlineAccountOpening/productSchema'
import Documents from '../modules/onlineAccountOpening/documents'

export interface RouteModel {
  path?: any
  component?: React.ComponentType<RouteComponentProps>
  exact?: boolean
}

export const RouteList = [
  {
    path: '/dashboard',
    component: DashboardWrapper,
    exact: true,
  },
  {
    path: '/cms/content',
    component: ContentManager,
    exact: true,
  },

  {
    path: '/cms/menu-manager',
    component: MenuManager,
    exact: true,
  },
  {
    path: '/cms/banner',
    component: Banner,
    exact: true,
  },

  {
    path: '/popup/text-popup',
    component: TextPopup,
    exact: true,
  },

  {
    path: '/popup/road-block-popup',
    component: RoadBlockPopup,
    exact: true,
  },
  {
    path: '/cms/manage-faqs',
    component: FaqCategory,
    exact: true,
  },
  {
    path: '/cms/update-faqs/:id',
    component: FaqManager,
    exact: true,
  },
  {
    path: '/cms/email-template',
    component: EmailTemplate,
    exact: true,
  },

  {
    path: '/usermanagement/users',
    component: UserManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/user-role',
    component: UserRoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/role',
    component: RoleManagementIndex,
    exact: true,
  },
  {
    path: '/usermanagement/departments',
    component: Departments,
    exact: true,
  },
  {
    path: '/usermanagement/branch',
    component: Branches,
    exact: true,
  },
  {
    path: '/dashzen-report/menu',
    component: ReportMenuComponent,
    exact: true,
  },
  {
    path: '/sitesetting/module',
    component: ModuleManager,
    exact: true,
  },
  {
    path: '/sitesetting/contact-setting',
    component: ContactSetting,
    exact: true,
  },
  {
    path: '/sitesetting/homepage-setting',
    component: HomepageSetting,
    exact: true,
  },
  {
    path: '/sitesetting/backend-setting',
    component: BackendSettings,
    exact: true,
  },
  {
    path: '/sitesetting/bank-setting',
    component: BankSettings,
    exact: true,
  },
  {
    path: '/sitesetting/setting',
    component: Settings,
    exact: true,
  },
  {
    path: '/sitesetting/smtp-setting',
    component: SmtpSettings,
    exact: true,
  },
  {
    path: '/sitesetting/key-setting',
    component: KeySettings,
    exact: true,
  },

  // Products Schema
  {
    path: '/online-account-opening/documents',
    component: Documents,
    exact: true,
  },
  {
    path: '/online-account-opening/product-schema',
    component: ProductSchema,
    exact: true,
  },

  // BPM Form
  {
    path: '/form-generator',
    component: lazy(async () => await import('../modules/laravelForm/generator/index')),
    exact: true,
  },
  {
    path: '/form-manager',
    component: lazy(async () => await import('../modules/laravelForm/manager/index')),
    exact: true,
  },

  // New Cif Application
  {
    path: '/online-accounts/nagarik-accounts',
    component: lazy(
      async () => await import('../modules/newCifApplication/table/NagarikApplicationTable')
    ),
    exact: true,
  },
  {
    path: '/online-accounts/kiosk-accounts',
    component: lazy(
      async () => await import('../modules/newCifApplication/table/KioskApplicationTable')
    ),
    exact: true,
  },
  {
    path: '/online-accounts/nagarik-accounts/:module/:case_id',
    component: lazy(async () => await import('../modules/newCifApplication/onlineScreenPage')),
  },
  {
    path: '/online-accounts/kiosk-accounts/:module/:case_id',
    component: lazy(async () => await import('../modules/newCifApplication/onlineScreenPage')),
  },
  // RO Accounts
  {
    path: '/ro-account-opening-branch',
    component: lazy(async () => await import('../modules/roOnlineAccount')),
    exact: true,
  },
  {
    path: '/ro-account-opening-branch/:module/:case_id',
    component: lazy(async () => await import('../modules/roOnlineAccount/RoOnlineScreenPage')),
  },

  // Customer Online Account
  {
    path: '/customer-online-account',
    component: lazy(
      async () => await import('../modules/customerOnlineAccount/customerOnlineAccounts')
    ),
    exact: true,
  },
  {
    path: '/customer-online-account/customer-account/final-review/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/customerOnlineAccount/customerOnlineAccounts/CustomerOnlineScreenPage'
        )
    ),
  },
  {
    path: '/preliminary-unverified',
    component: lazy(
      async () => await import('../modules/customerOnlineAccount/preliminary-unverified')
    ),
    exact: true,
  },

  // RO Account Opening
  {
    path: '/ro-account-opening',
    component: lazy(async () => await import('../modules/quickAccountOpening')),
    exact: true,
  },
  {
    path: '/ro-account-opening/ro-account-opening-form',
    component: lazy(
      async () => await import('../modules/quickAccountOpening/quickAccountOpeningScreenPage')
    ),
    staticName: '',
    exact: true,
  },
  {
    path: '/ro-account-opening/ro-account-opening-form-completed/:case_id',
    component: lazy(async () => await import('../modules/quickAccountOpening/completedScreenPage')),
    staticName: '',
    exact: true,
  },
  {
    path: '/ro-account-opening/ro-account-opening-form/:case_id',
    component: lazy(
      async () => await import('../modules/quickAccountOpening/quickAccountOpeningScreenPage')
    ),
    staticName: '',
    exact: true,
  },

  // New Account Closure
  {
    path: '/account-closure',
    component: lazy(async () => await import('../modules/accountClosure')),
    exact: true,
  },
  {
    path: '/account-closure/account-closure-form',
    component: lazy(async () => await import('../modules/accountClosure/accountClosureScreenPage')),
    staticName: '',
    exact: true,
  },
  {
    path: '/account-closure/account-closure-form/:case_id',
    component: lazy(async () => await import('../modules/accountClosure/accountClosureScreenPage')),
    staticName: '',
    exact: true,
  },

  // New Corporate Account
  {
    path: '/new-corporate-account',
    component: lazy(async () => await import('../modules/newCorporateAccount')),
    exact: true,
  },
  // New CIF New Account
  {
    path: '/new-cif-new-account',
    component: lazy(async () => await import('../modules/newCifNewAccount')),
    exact: true,
  },
  {
    path: '/corporate-new-cif-new-account',
    component: lazy(async () => await import('../modules/corporateNewCifNewAccount')),
    exact: true,
  },

  {
    path: '/new-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/rejectedList/accountRejectedList')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/account-opening-requests',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/Individual/normalIndividualForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/Individual/finalForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/account-opening-status',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/account-status/AccountStatus'
        )
    ),
    staticName: 'Account Status',
    exact: true,
  },
  {
    path: '/summary-report',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/summary-report/SummaryReport'
        )
    ),
    staticName: 'Summary Report',
    exact: true,
  },
  {
    path: '/accounts/account-closure',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/account-closure-report/AccountClosureReport'
        )
    ),
    staticName: 'Account Status',
    exact: true,
  },
  {
    path: '/log-report',
    component: lazy(async () => await import('../modules/logViewer')),
    staticName: 'Log Report',
    exact: true,
  },
  {
    path: '/logs/mail-logs',
    component: lazy(async () => await import('../modules/mailLogs')),
    staticName: 'Mail Logs',
    exact: true,
  },
  {
    path: '/accounts/ancillary-services',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/ancillaryServices/index')
    ),
    staticName: 'Ancillary Services',
    exact: true,
  },

  // Retail Account
  {
    path: '/new-cif-new-account/create-new-account/individualScreenForm/:case_id',
    component: lazy(
      async () =>
        await import('../modules/screening/individualJointMinorScreening/individualScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/individualScreenForm',
    component: lazy(
      async () =>
        await import('../modules/screening/individualJointMinorScreening/individualScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/ncnacorporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/ncnacorporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // Seperate Corporate Module
  {
    path: '/corporate-new-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/ncnacorporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/corporate-new-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/ncnacorporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  //Centralized Corporate
  {
    path: '/new-corporate-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/ncnaNormalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/ncnaNormalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account/corporate-final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/corporate/ncnaCorporate')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  //Seperate Corporate Module
  {
    path: '/corporate-new-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/ncnaNormalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/corporate-new-cif-new-account/create-new-account/corporate-final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/corporate/ncnaCorporate')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // Corporate Account List
  {
    path: '/new-corporate-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/newCorporateAccount/rejectedList/accountRejectedList')
    ),
    exact: true,
  },
  {
    path: '/new-corporate-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/corporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-corporate-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/corporateScreenPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-corporate-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-corporate-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-corporate-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/newCifNewAccount/branchMaker/components/corporate/normalCorporateForm'
        )
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-cif-new-account/create-new-account',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchMaker/accountOpeningRequestPage')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  {
    path: '/new-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },
  {
    path: '/new-corporate-account/create-new-account/corporate-final-form/:case_id',
    component: lazy(
      async () =>
        await import('../modules/newCifNewAccount/branchMaker/components/corporate/finalForm')
    ),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  // DMS Module (new-form-generator flow, nested under the authorized
  // new-cif-new-account alias — a brand-new prefix would never render)
  {
    path: '/retail-account-opening',
    component: lazy(async () => await import('../modules/dmsModule')),
    staticName: 'Retail Account Opening',
    exact: true,
  },
  // {
  //   path: '/retail-account-opening/form',
  //   component: lazy(async () => await import('../modules/dmsModule/pages/DmsModulePage')),
  //   staticName: 'Retail Account Opening',
  //   exact: true,
  // },
  // {
  //   path: '/retail-account-opening/form/:case_id',
  //   component: lazy(async () => await import('../modules/dmsModule/pages/DmsModulePage')),
  //   staticName: 'Retail Account Opening',
  //   exact: true,
  // },
  // Old-style DMS entry (legacy formGenerator flow — individual-dms-flow slug).
  // Nested under the authorized /retail-account-opening prefix so it renders.
  {
    path: '/retail-account-opening/account-type',
    component: lazy(async () => await import('../modules/dmsModule/oldStyleForm')),
    staticName: 'Retail Account Opening',
    exact: true,
  },
  {
    path: '/retail-account-opening/form',
    component: lazy(async () => await import('../modules/dmsModule/oldStyleForm/OldStyleFormPage')),
    staticName: 'Retail Account Opening',
    exact: true,
  },
  {
    path: '/retail-account-opening/form/:case_id',
    component: lazy(async () => await import('../modules/dmsModule/oldStyleForm/OldStyleFormPage')),
    staticName: 'Retail Account Opening',
    exact: true,
  },
  {
    path: '/retail-account-opening/form/individual/:case_id',
    component: lazy(async () => await import('../modules/dmsModule/oldStyleForm/Individual/index')),
    staticName: 'Retail Account Opening',
    exact: true,
  },

  {
    path: '/retail-account-opening/form/joint/:case_id',
    component: lazy(async () => await import('../modules/dmsModule/oldStyleForm/joint/index')),
    staticName: 'Retail Account Opening',
    exact: true,
  },
  {
    path: '/retail-account-opening/form/minor/:case_id',
    component: lazy(async () => await import('../modules/dmsModule/oldStyleForm/minor/index')),
    staticName: 'Retail Account Opening',
    exact: true,
  },
  // New CIF Only
  {
    path: '/new-cif-only',
    component: lazy(async () => await import('../modules/newCIFOnly/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/OpeningRequestPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/individual-cif-form',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/NewCifOpenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/corporate-cif-form',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/CorporateCifScreenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/individual-cif-form/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Individual/NewCifOpenPage')
    ),
    exact: true,
  },
  {
    path: '/new-cif-only/opening-requests/corporate-cif-form/:case_id',
    component: lazy(
      async () => await import('../modules/newCIFOnly/branchMaker/Corporate/CorporateCifScreenPage')
    ),
    exact: true,
  },
  // newCifAccountTest module (new-form-generator reference module). Nested under
  // the authorized /new-cif-only alias so the PrivateRoutes alias gate renders it.
  {
    path: '/new-cif-only/new-cif-account-test',
    component: lazy(async () => await import('../modules/newCifAccountTest/index')),
    exact: true,
  },
  {
    path: '/new-cif-only/new-cif-account-test/:case_id',
    component: lazy(async () => await import('../modules/newCifAccountTest/index')),
    exact: true,
  },

  // Existing CIF New Account
  {
    path: '/existing-cif-new-account',
    component: lazy(async () => await import('../modules/existingCIFNewAccount/index')),
    exact: true,
  },

  {
    path: '/existing-cif-new-account/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/existingCIFNewAccount/rejectedList/accountRejectedList')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/opening-requests',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/accountOpeningRequestPage'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/individualScreenForm',
    component: lazy(
      async () =>
        await import(
          '../modules/screening/individualJointMinorScreening/existingIndividualScreening'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/individualScreenForm/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/screening/individualJointMinorScreening/existingIndividualScreening'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporateScreenForm',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/existingCorporateScreening')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporateScreenForm/:case_id',
    component: lazy(
      async () => await import('../modules/screening/corporateScreening/existingCorporateScreening')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/normal-individual-preliminary-form',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/Individual/normalIndividualForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/create-new-account/normal-individual-preliminary-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/Individual/normalIndividualForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/create-new-account/corporate-form',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/corporate/normalCorporateForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },
  {
    path: '/existing-cif-new-account/create-new-account/corporate-form/:case_id',
    component: lazy(
      async () =>
        await import(
          '../modules/existingCIFNewAccount/branchMakerChecker/corporate/normalCorporateForm'
        )
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-corporate',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/corporate/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  {
    path: '/existing-cif-new-account/branch-checker-review-individual',
    component: lazy(
      async () => await import('../modules/newCifNewAccount/branchChecker/Individual/index')
    ),
    staticName: 'Existing CIF New Accounts',
    exact: true,
  },

  //ENquiry Module

  {
    path: '/cms/forms-and-download',
    component: FormDownloadComponent,
    exact: true,
  },

  //Customer Review

  {
    path: '/customer-review',
    component: lazy(async () => await import('../modules/customerReview')),
    exact: true,
  },
  {
    path: '/customer-review/form',
    component: lazy(async () => await import('../modules/customerReview/Forms/ReviewForm')),
    exact: true,
  },
  {
    path: '/customer-review/form/individual',
    component: lazy(async () => await import('../modules/customerReview/Forms/Individual')),
    exact: true,
  },
  {
    path: '/customer-review/form/corporate',
    component: lazy(async () => await import('../modules/customerReview/Forms/Corporate')),
    exact: true,
  },

  //ALOI MODULE

  {
    path: '/aloi-account-opening',
    component: lazy(async () => await import('../modules/aloiModule')),
    exact: true,
  },

  {
    path: '/aloi-account-opening/rejected-account-lists',
    component: lazy(
      async () => await import('../modules/aloiModule/rejectedList/accountRejectedList')
    ),
    exact: true,
  },
  {
    path: '/aloi-account-opening/create-new-account/final-form/:case_id',
    component: lazy(async () => await import('../modules/aloiModule/forms/finalForm')),
    staticName: 'New CIF New Accounts',
    exact: true,
  },

  //REASSIGN CASE MODULE

  {
    path: '/reassign-case',
    component: lazy(async () => await import('../modules/reassignCase')),
    exact: true,
  },

  //EXTERNAL SOURCE ACCOUNT OPENING MODULE

  {
    path: '/external-source-account-opening',
    component: lazy(async () => await import('../modules/externalSourceAccountOpening')),
    exact: true,
  },
  {
    path: '/external-source-account-opening/:id',
    component: lazy(
      async () =>
        await import('../modules/externalSourceAccountOpening/detail/ExternalSourceDetail')
    ),
  },

  //REPORT SUPERSET MODULE

  {
    path: '/dashzen-report/dashboard',
    component: lazy(async () => await import('../modules/reportingSupersetModule')),
    exact: true,
  },
  {
    path: '/dashzen-report/:name',
    component: lazy(
      async () => await import('../modules/reportingSupersetModule/SupersetReportPage')
    ),
    exact: true,
  },

  //OAUTH CLIENTS

  {
    path: '/oauth-clients',
    component: lazy(async () => await import('../modules/oauthClients/components/OAuthClients')),
    exact: true,
  },
]
